export const environment = {
  production: false,
  apiUrl: 'https://dev-ai-smartgrader-api-gcgvhkepgsc7ceee.centralindia-01.azurewebsites.net/api',

  // ── Diagram upload constraints ── keep in sync with appsettings.json DiagramSettings
  diagramMaxFileSizeBytes: 5 * 1024 * 1024,          // 5 MB
  diagramAllowedMimeTypes: ['image/png', 'image/jpeg', 'image/jpg'],
  diagramAllowedLabel:     'PNG, JPG or JPEG',
};